export { ImageLoader } from './image-loader.component';
export type { IImageLoaderProps, IImageLoaderChildrenProps } from './image-loader.component';
